import { Activity, Add, ArchiveBook, ArrangeHorizontal, ArrowCircleLeft, ArrowCircleRight, ArrowDown, ArrowDown2, ArrowLeft, ArrowLeft2, ArrowRight, ArrowRight2, ArrowSquareLeft, ArrowSquareRight, ArrowUp, ArrowUp2, Award, Bank, Barcode, Book1, Box, Box1, BoxAdd, BoxRemove, BoxTime, Building, Buildings2, Calendar, CalendarAdd, CalendarRemove, CalendarTick, Call, Camera, Card, CardPos, Category, Chart, ClipboardText, ClipboardTick, Clock, CloseCircle, CloseSquare, CloudCross, Coin1, Convert, Copy, Crown1, Danger, DiscountShape, DocumentDownload, DocumentText, DocumentText1, DocumentUpload, Drop, Edit2, Element3, EmptyWallet, ExportCurve, ExportSquare, Eye, EyeSlash, Filter, Flag, Gallery, GalleryAdd, Gift, Global, Grid3, HambergerMenu, Health, Heart, HeartTick, Hierarchy, Home2, Hospital, ImportSquare, InfoCircle, Instagram, Judge, Key, Link21, Location, Lock1, LoginCurve, LogoutCurve, Maximize4, MagicStar, Magicpen, Map, Map1, MedalStar, MenuBoard, MessageQuestion, Messages2, Minus, Mobile, MoneyRecive, MoneySend, Moneys, Monitor, Moon, More, Note, Notification, Pause, PenTool2, People, PercentageSquare, Personalcard, Play, PresentionChart, Printer, Profile, Profile2User, Ranking, Receipt1, ReceiptText, Refresh2, RotateRight, Routing, ScanBarcode, Save2, SearchNormal1, SecuritySafe, Send2, Setting2, Share, ShieldSlash, ShieldTick, Shop, Sms, Sort, Stop, Star1, Sun1, Task, TickCircle, TickSquare, TicketDiscount, Timer1, Trash, UserTick, TrendDown, TrendUp, User, UserAdd, Verify, Wallet2, Warning2, Whatsapp, } from './iconsax.js';
/**
 * ════════════════════════════════════════════════════════════════════════════
 *  THE ICON VOCABULARY — one map, four surfaces
 * ════════════════════════════════════════════════════════════════════════════
 *
 * Keys are what Bookora MEANS, in kebab-case; values are the Iconsax glyph that
 * currently carries the meaning. A screen asks for `consent-signed`, not for
 * `ClipboardTick`, so re-pointing the whole product at a better glyph is a
 * one-line edit here — and a search for who draws a consent is a search for one
 * string rather than for a component that eight features imported for eight
 * different reasons.
 *
 * ── WHAT IS DELIBERATELY ABSENT ─────────────────────────────────────────────
 *
 * There is no `chevron-left`, no `arrow-right`, no physical horizontal name of
 * any kind. Those live in `DIRECTIONAL_ICONS` under logical names and are
 * resolved against the document direction. A test asserts this map stays free
 * of them.
 *
 * ── SUBSTITUTIONS WORTH KNOWING ─────────────────────────────────────────────
 *
 *   injection  Iconsax has no syringe. `Drop` is the nearest honest reading for
 *              an injectable — it is also what the volume/units column means.
 *   procedure  `Magicpen` rather than a scalpel: this is aesthetic medicine and
 *              the clinic's own word for it is «خدمت», not «جراحی».
 *   offline    Iconsax has `Wifi` but no crossed-out wifi. `CloudCross` says
 *              "the server is unreachable", which is the actual PWA state.
 *   telegram   Iconsax has no Telegram mark. The Astro site keeps its inlined
 *              brand path for that one; brand logos are not a UI icon set's job.
 */
export const ICONS = {
    // ── Clinical & care ──────────────────────────────────────────────────────
    patient: User,
    'patient-add': UserAdd,
    'patient-card': Personalcard,
    patients: Profile2User,
    staff: People,
    clinic: Hospital,
    calendar: Calendar,
    'calendar-add': CalendarAdd,
    'calendar-tick': CalendarTick,
    'calendar-remove': CalendarRemove,
    clock: Clock,
    timer: Timer1,
    session: Health,
    injection: Drop,
    procedure: Magicpen,
    'treatment-plan': Task,
    camera: Camera,
    photos: Gallery,
    'photo-add': GalleryAdd,
    compare: Convert,
    document: DocumentText,
    article: DocumentText1,
    consent: ClipboardText,
    'consent-signed': ClipboardTick,
    signature: PenTool2,
    aftercare: HeartTick,
    note: Note,
    chart: Chart,
    report: PresentionChart,
    activity: Activity,
    'trend-up': TrendUp,
    'trend-down': TrendDown,
    // ── Inventory ────────────────────────────────────────────────────────────
    inventory: Box,
    lot: Box1,
    'stock-in': BoxAdd,
    'stock-out': BoxRemove,
    expiry: BoxTime,
    barcode: Barcode,
    scan: ScanBarcode,
    // ── Money ────────────────────────────────────────────────────────────────
    wallet: Wallet2,
    'wallet-empty': EmptyWallet,
    receipt: Receipt1,
    invoice: ReceiptText,
    card: Card,
    pos: CardPos,
    money: Moneys,
    coin: Coin1,
    income: MoneyRecive,
    expense: MoneySend,
    discount: DiscountShape,
    coupon: TicketDiscount,
    percent: PercentageSquare,
    bank: Bank,
    plan: Crown1,
    // ── Nav & chrome ─────────────────────────────────────────────────────────
    menu: HambergerMenu,
    dashboard: Element3,
    category: Category,
    search: SearchNormal1,
    filter: Filter,
    sort: Sort,
    bell: Notification,
    settings: Setting2,
    logout: LogoutCurve,
    login: LoginCurve,
    profile: Profile,
    home: Home2,
    shop: Shop,
    more: More,
    add: Add,
    minus: Minus,
    edit: Edit2,
    trash: Trash,
    copy: Copy,
    refresh: Refresh2,
    // Turning an image a quarter turn clockwise. A PHYSICAL rotation — it is the
    // same turn in both scripts, so it is not in `DIRECTIONAL_ICONS`. Not
    // `refresh`: that one means "load again", and a page viewer used it for both.
    rotate: RotateRight,
    // «اندازهٔ کامل» / fit to the frame. Four corners pointing out; `monitor`
    // (the old stand-in) means the display theme everywhere else.
    fit: Maximize4,
    save: Save2,
    // Run/pause/stop are the console's queue controls. Iconsax's `Play` is
    // already `play` (video), and these three read as one set beside it.
    pause: Pause,
    stop: Stop,
    // «ورود به‌جای کاربر» — impersonation. A ticked user, not an eye: the eye
    // means "view" everywhere else in this product and impersonation is not
    // viewing, it is acting.
    impersonate: UserTick,
    // Switching the active clinic. Two horizontal arrows, so it is DIRECTIONAL by
    // eye but symmetric in fact — `ArrangeHorizontal` mirrors itself.
    switch: ArrangeHorizontal,
    export: ExportSquare,
    import: ImportSquare,
    download: DocumentDownload,
    upload: DocumentUpload,
    print: Printer,
    link: Link21,
    external: ExportCurve,
    eye: Eye,
    'eye-off': EyeSlash,
    lock: Lock1,
    key: Key,
    shield: ShieldTick,
    security: SecuritySafe,
    'shield-off': ShieldSlash,
    sun: Sun1,
    moon: Moon,
    monitor: Monitor,
    mobile: Mobile,
    'view-grid': Grid3,
    'view-list': MenuBoard,
    // Vertical chevrons and arrows carry no direction: `up` is `up` in both
    // scripts. Their horizontal counterparts are in `DIRECTIONAL_ICONS`.
    'chevron-up': ArrowUp2,
    'chevron-down': ArrowDown2,
    'arrow-up': ArrowUp,
    'arrow-down': ArrowDown,
    // ── States ───────────────────────────────────────────────────────────────
    check: TickCircle,
    'check-square': TickSquare,
    close: CloseCircle,
    'close-square': CloseSquare,
    info: InfoCircle,
    warning: Warning2,
    danger: Danger,
    verified: Verify,
    offline: CloudCross,
    // ── Directory, content & marketing ───────────────────────────────────────
    location: Location,
    map: Map,
    district: Map1,
    city: Building,
    clinics: Buildings2,
    directions: Routing,
    call: Call,
    sms: Sms,
    chat: Messages2,
    send: Send2,
    website: Global,
    instagram: Instagram,
    whatsapp: Whatsapp,
    star: Star1,
    heart: Heart,
    award: Award,
    medal: MedalStar,
    ranking: Ranking,
    sparkle: MagicStar,
    // «راهنما» — the Help entry, tour chips and the guidance hub. A question in a
    // speech bubble: help you can ask for, not a warning (`info`) and not the
    // smart guide's suggestions (`sparkle`).
    help: MessageQuestion,
    gift: Gift,
    share: Share,
    play: Play,
    blog: Book1,
    encyclopedia: MenuBoard,
    audit: ArchiveBook,
    queue: Hierarchy,
    flag: Flag,
    moderation: Judge,
};
/**
 * ── DIRECTIONAL NAMES ───────────────────────────────────────────────────────
 *
 * `start`/`end` are the layout edges: in RTL, start is RIGHT.
 * `back`/`forward` are the reading flow: **back points toward the start**, so
 * in RTL the back button's chevron points RIGHT and "next page" points LEFT.
 *
 * `back`/`forward` are aliases of `start`/`end` rather than a second concept.
 * They exist because a call site that means "return to the previous screen"
 * should not have to translate that into an edge, and a reviewer reading
 * `name="chevron-back"` on a back button can tell it is right without knowing
 * which side the sidebar is on today.
 *
 * Keyboard semantics follow the same mapping and are the other half of this:
 * in an RTL tab list `ArrowLeft` moves FORWARD. Radix's `Tabs`/`Menu` get that
 * right only when the portal actually carries `dir="rtl"` — see the panels'
 * providers, not this file.
 */
export const DIRECTIONAL_ICONS = {
    'chevron-start': { rtl: ArrowRight2, ltr: ArrowLeft2 },
    'chevron-end': { rtl: ArrowLeft2, ltr: ArrowRight2 },
    'chevron-back': { rtl: ArrowRight2, ltr: ArrowLeft2 },
    'chevron-forward': { rtl: ArrowLeft2, ltr: ArrowRight2 },
    'arrow-start': { rtl: ArrowRight, ltr: ArrowLeft },
    'arrow-end': { rtl: ArrowLeft, ltr: ArrowRight },
    'arrow-back': { rtl: ArrowRight, ltr: ArrowLeft },
    'arrow-forward': { rtl: ArrowLeft, ltr: ArrowRight },
    'arrow-circle-back': { rtl: ArrowCircleRight, ltr: ArrowCircleLeft },
    'arrow-circle-forward': { rtl: ArrowCircleLeft, ltr: ArrowCircleRight },
    'page-first': { rtl: ArrowSquareRight, ltr: ArrowSquareLeft },
    'page-last': { rtl: ArrowSquareLeft, ltr: ArrowSquareRight },
};
const DIRECTIONAL_NAME_SET = new Set(Object.keys(DIRECTIONAL_ICONS));
export function isDirectionalIcon(name) {
    return DIRECTIONAL_NAME_SET.has(name);
}
/** Every name the product may ask for, sorted — the registry's public index. */
export const ICON_NAMES = [
    ...Object.keys(ICONS),
    ...Object.keys(DIRECTIONAL_ICONS),
].sort();
/**
 * Name + direction → glyph. The single place a logical name becomes a physical
 * one; nothing above this line knows that `chevron-back` has two answers.
 */
export function resolveIcon(name, dir) {
    if (isDirectionalIcon(name))
        return DIRECTIONAL_ICONS[name][dir];
    return ICONS[name];
}
//# sourceMappingURL=registry.js.map